import { authHeader } from '@/_helpers'
export const delivrabilityService = {
  getDelivrability
}

const apiUrl = process.env.VUE_APP_ROOT_API

function getDelivrability(params) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter: params }),
  }
  return fetch(`${apiUrl}/delivrability/report`, requestOptions).then(handleResponse)
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      const error = data || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
